import { configure } from "mobx";

const isDev = process.env.NODE_ENV === "development";

configure({
  enforceActions: "always",
  computedRequiresReaction: !isDev,
  reactionRequiresObservable: !isDev,
  observableRequiresReaction: !isDev,
  disableErrorBoundaries: !isDev,
});

export * from "./env";
export * from "./mobx/core/invoice/model.invoice";
export * from "./mobx/core/invoice/store.invoice";
export * from "./mobx/core/meter/model.meter";
export * from "./mobx/core/meter/model.meter-reading";
export * from "./mobx/core/nudge/model.nudge";
export * from "./mobx/core/organization/model.organization";
export * from "./mobx/core/payment/model.payment";
export * from "./mobx/core/service-account/model.service-account";
export * from "./mobx/core/user/model.user";
export * from "./mobx/create";
export * from "./mobx/root";
export { api } from "./orpc/client";
export * from "./table";
export type { TModel } from "./mobx/lib/models/t-model";
